export default __webpack_public_path__ + "static/media/finacial-solutions.a6aa58ef.png";